module.exports = __webpack_public_path__ + "img/niue.6b72e830.jpg";